import React, { Component } from "react";
import {connect} from "react-redux";
import { Col, Row } from "react-bootstrap";
import Modal from "react-responsive-modal";
import Table from "react-table";
import "react-table/react-table.css";
import "./DeviceConfigModalTable.css";
import "./DeviceConfigModal.css";
import DashboardService from "../services/DashboardService";
import imageURIs from "../resources/ImageURIs";
import { NAVTYPE } from "../constants/Constants";

class DeviceConfigModal extends Component {

  EVENT = {
    MOTION: "MOTION",
    AMBIENT: "AMBIENT",
    LED: "LED",
    BUTTON: "BUTTON"
  }

  state = {
    userId: "",
    deviceName: "",
    areaName: "",
    premiseName: "",
    schedulesArr: [],
    activeScheduleId: "",
    scenesArr: [],
    activeSceneId: "",
    isSchedulesProfiles: null,
    isSchedulesTab: null,
    schedulesTabArr: [],
    isScenesTab: null,
    scenesTabArr: [],
    sceneIdsArr: [],
    macAddress: "",
    macId: "",
    macIdSet: false,
    isActive: "",
    tableData: [],
    scheduleProfileColumns: [],
    scheduleColumns: [],
    columnSchedule: [],
    scheduleArr: [],
    profileArr: [],
    schedulesTabData: [],
    scenesTabData: [],
    columnScene: [],
    isGroupTab: null,
    shadowGroupConfig: {},
    groupTabData: [],
    groupColumns: [],
    isGlobalSettingsTab: null,
    globalSettingsTabData: [],
    columnGlobalSettings: []
  };



  async componentDidUpdate(prevProps) {
    if (this.props.configtimestamp !== prevProps.configtimestamp) {
      await this.setState({ userId: this.props.configUserId, premiseName: this.props.configPremiseName, areaName: this.props.configdevicAreaName, deviceName: this.props.configdeviceName, macAddress: this.props.configMacId, macIdSet: true });
      this.setDeviceConfigDetails(this.props.configMacId);
    }
  }

  setDeviceConfigDetails(macId) {
    if (this.state.macIdSet === true) {
      this.getSchedulesProfiles(macId);
    }
  }

  async getSchedulesProfiles(macAddress) {
    this.setState({ schedulesArr: [], isSchedulesProfiles: null, activeScheduleId: "", scenesArr: [], activeSceneId: "", scheduleProfileColumns: [], tableData: [], scheduleArr: [], profileArr: [] });
    const schedulesProfiles = await (DashboardService.getScheduleProfile(macAddress));
    let schedulesArr = [];
    let scenesArr = [];
    let activeSceneId = "-";
    let activeScheduleId = "";
    if (schedulesProfiles.rawShadow.config !== undefined) {
      if (schedulesProfiles.rawShadow.config.hasOwnProperty('schedules') && schedulesProfiles.rawShadow.config.schedules.length > 0) {
        schedulesArr = schedulesProfiles.rawShadow.config.schedules;
        this.setState({ isSchedulesProfiles: true });
      } else {
        this.setState({ isSchedulesProfiles: false });
      }
      if (schedulesProfiles.rawShadow.config.hasOwnProperty('scenes') && schedulesProfiles.rawShadow.config.scenes.length > 0) {
        for (let counter = 0; counter < schedulesProfiles.rawShadow.config.scenes.length; counter++) {
          if (counter === schedulesProfiles.rawShadow.config.scenes.length - 1) {
            scenesArr.push(schedulesProfiles.rawShadow.config.scenes[counter].SId);
          } else {
            scenesArr.push(schedulesProfiles.rawShadow.config.scenes[counter].SId + ", ");
          }
        }
      } else {
        scenesArr.push("-");
      }
      if (schedulesProfiles.rawShadow.ActSceneId !== undefined) {
        activeSceneId = schedulesProfiles.rawShadow.ActSceneId;
        if (activeSceneId === 0) {
          activeSceneId = "-";
        }
      }
      if (schedulesProfiles.rawShadow.ActSchId !== undefined) {
        activeScheduleId = schedulesProfiles.rawShadow.ActSchId;
      }

      let groupConfig = {}
      if(schedulesProfiles.rawShadow.config.hasOwnProperty('group')) {
        groupConfig = this.setGroupConfigFromShadow(schedulesProfiles.rawShadow.config.group);
      }

      this.setState({ schedulesArr: schedulesArr, activeScheduleId: activeScheduleId, scenesArr: scenesArr, activeSceneId: activeSceneId, shadowGroupConfig: groupConfig});
      this.displaySchedulesProfiles();
    } else {
      this.setState({ isSchedulesProfiles: false });
    }
  }
  


  async getSchedulesProfilesReload(macAddress) {
    this.getSchedulesProfiles(macAddress);
  }


  async getSchedules() {
    this.setState({ schedulesTabArr: [], schedulesTabData: [], columnSchedule: [], isSchedulesTab: null, active_schedule: "", scheduleColumns: [] });
    let schedulesData = [];
    schedulesData = await (DashboardService.getSchedules(this.state.macAddress));
    if (schedulesData.schedules !== undefined && schedulesData.schedules.length > 0) {
      this.setState({ schedulesTabArr: schedulesData.schedules, isActive: NAVTYPE.SCHEDULES, isSchedulesTab: null });
      this.displaySchedules();
    } else {
      this.setState({ isActive: NAVTYPE.SCHEDULES, isSchedulesTab: false });
    }
  }


  async getScenes() {
    const scenesData = await (DashboardService.getScenes(this.state.macAddress));
    let sceneIdArr = [];
    if (scenesData.scenes !== undefined && scenesData.scenes.length > 0) {
      if (this.state.isActive === NAVTYPE.SCENES) {
        this.setState({ scenesTabArr: scenesData.scenes, sceneIdsArr: sceneIdArr, isScenesTab: true });
        this.setState({ scenesTabArr: scenesData.scenes, isScenesTab: true });
        this.displayScenes();
      }
    } else {
      if (this.state.isActive === NAVTYPE.SCENES) {
        this.setState({ scenesTabArr: scenesData.scenes, sceneIdsArr: sceneIdArr, isScenesTab: false });
      }
    }
  }

  async getGlobalSettings() {
    const settings = await (DashboardService.getGlobalSettings(this.state.macAddress));
    if (settings.hasOwnProperty('id') && settings.id > 0) {
      if (this.state.isActive === NAVTYPE.GLOBAL_SETTINGS) {
        this.setState({ isGlobalSettingsTab: true });
        this.displayGlobalSettings(settings);
      }
    } else {
      if (this.state.isActive === NAVTYPE.GLOBAL_SETTINGS) {
        this.setState({ isGlobalSettingsTab: false });
      }
    }
  }

  changeActiveNavPill = type => {
    switch (type) {
      case NAVTYPE.SCHEDULES: {
        this.getSchedules();
        break;
      }
      case NAVTYPE.SCENES: {
        this.setState({ isActive: NAVTYPE.SCENES, isScenesTab: null });
        this.getScenes();
        break;
      }
      case NAVTYPE.GROUPS: {
        this.setState({ isActive: NAVTYPE.GROUPS });
        this.getGroups();
        break;
      }
      case NAVTYPE.GLOBAL_SETTINGS: {
        this.setState({ isActive: NAVTYPE.GLOBAL_SETTINGS });
        this.getGlobalSettings();
        break;
      }
    }
  };


  onCloseClicked = () => {
    this.setState({ userId: "", premiseName: "", areaName: "", deviceName: "", isSchedulesProfiles: false, macIdSet: false, isSchedulesTab: null, isScenesTab: null, isGlobalSettingsTab: null, schedulesArr: [], activeScheduleId: "", schedulesTabArr: [], sceneIdsArr: [], isActive: "", tableData: [], scheduleProfileColumns: [], scheduleColumns: [], columnSchedule: [], scheduleArr: [], profileArr: [], schedulesTabData: [], scenesTabData: [], columnScene: [] , columnGlobalSettings: [], globalSettingsTabData: []});
    this.props.onCloseClicked();
  };


  displaySchedulesProfiles() {
    let scheduleProfileColumns = [];
    if (this.state.schedulesArr.length > 0) {
      for (let counter = 0; counter < this.state.schedulesArr.length; counter++) {
        this.state.scheduleArr.push(this.state.schedulesArr[counter].SId);
      }
      for (let counter = 0; counter < this.state.schedulesArr.length; counter++) {
        this.state.profileArr.push(this.state.schedulesArr[counter].PId);
      }
      if (this.state.scheduleArr.length > 0) {
        let cntr = 0;
        let accFirstCol = "col" + cntr;
        scheduleProfileColumns.push(
          {
            Header: "Schedule Id",
            accessor: accFirstCol,
            style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: "#cfd5e9", color: "#000000" },
            headerStyle: { textAlign: "center", background: "#cfd5e9", borderRight: "1px solid #FFFFFF", borderBottom: "1px solid #FFFFFF", color: "#000000" },
          }
        );
        for (let cnt = 0; cnt < this.state.scheduleArr.length; cnt++) {
          cntr++;
          var accNextCol = "col" + cntr;
          var hdr = "" + this.state.scheduleArr[cnt];
          scheduleProfileColumns.push(
            {
              Header: hdr,
              accessor: accNextCol,
              style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: this.state.scheduleArr[cnt] === this.state.activeScheduleId ? "#23b14d" : "#cfd5e9", color: this.state.scheduleArr[cnt] === this.state.activeScheduleId ? "#FFFFFF" : "#000000" },
              headerStyle: { textAlign: "center", borderRight: "1px solid #FFFFFF", borderBottom: "1px solid #FFFFFF", color: this.state.scheduleArr[cnt] === this.state.activeScheduleId ? "#FFFFFF" : "#000000", background: this.state.scheduleArr[cnt] === this.state.activeScheduleId ? "#23b14d" : "#cfd5e9" },
            }
          );
        }
      }
    }
    const tableData = [];
    let row2 = {};
    let cntr = 0;
    let acc = "col" + cntr;
    row2[acc] = "Profile Id";
    if (this.state.profileArr.length > 0) {
      for (var count = 0; count < this.state.profileArr.length; count++) {
        cntr = cntr + 1;
        let accs = "col" + cntr;
        row2[accs] = this.state.profileArr[count];
      }
      tableData.push(row2);
    }
    this.setState({ scheduleProfileColumns: scheduleProfileColumns, tableData: tableData });
  }

  displaySchedules() {
    this.state.scheduleColumns.push({
      "scheduleId": "Schedule Id",
      "scheduleName": "Name",
      "scheduleProfileId": "Profile Id",
      "scheduleHour": "Hour",
      "scheduleMinute": "Minute",
      "scheduleDuskDawnFlag": "Dusk Dawn Flag",
      "scheduleDuskDawnOffset": "Dusk Dawn Offset",
      "scheduleDaysOfWeek": "Days Of Week",
      "scheduleLastCmd": "Last Cmd",
      "scheduleSynchStatus": "Synch Status",
      "profile": "Profile",
      "id": "Profile Id",
      "name": "Name",
      "accountId": "Account Id",
      "lastCmd": "Last Cmd",
      "maxLoadLevel": "Max Load Level",
      "minLoadLevel": "Min Load Level",
      "lux": "Lux",
      "ambientLight": "Ambient Light",
      "activityTimeout": "Activity Time Out",
      "trigger": "Trigger",
      "beeperVolume": "Beeper Volume",
      "powerLedMax": "Power Led Max",
      "powerLedMin": "Power Led Min",
      "lingerTimeout": "Linger Timeout",
      "lingerLoadLevel": "Linger Load Level",
      "indLedMax": "Ind Led Max",
      "indLedMin": "Ind Led Min",
      "rampUp": "Ramp Up",
      "rampDown": "Ramp Down",
      "contAct": "Cont Act",
      "modeType": "Mode Type",
      "manualModeType": "Manual Mode Type",
      "manualModeTo": "Manual Mode To",
      "followPrevProfile": "Follow Prev Profile",
      "manualLoadOff": "Manual Load Off",
      "ledsAutoAdjust": "Leds Auto Adjust",
      "synchStatus": "Synch Status"
    });
    if (this.state.schedulesTabArr.length > 0) {
      for (let counter = 0; counter < this.state.schedulesTabArr.length; counter++) {
        let profile_followPrevProfile = this.state.schedulesTabArr[counter].profile.followPrevProfile;
        let profile_manualLoadOff = this.state.schedulesTabArr[counter].profile.manualLoadOff;
        let profile_ledsAutoAdjust = this.state.schedulesTabArr[counter].profile.ledsAutoAdjust;
        if (profile_followPrevProfile === false) {
          profile_followPrevProfile = "False";
        }
        if (profile_manualLoadOff === false) {
          profile_manualLoadOff = "False";
        }
        if (profile_ledsAutoAdjust === false) {
          profile_ledsAutoAdjust = "False";
        }
        this.state.scheduleColumns.push({
          "scheduleId": this.state.schedulesTabArr[counter].id,
          "scheduleName": this.state.schedulesTabArr[counter].name,
          "scheduleProfileId": this.state.schedulesTabArr[counter].profileId,
          "scheduleHour": this.state.schedulesTabArr[counter].hour,
          "scheduleMinute": this.state.schedulesTabArr[counter].minute,
          "scheduleDuskDawnFlag": this.state.schedulesTabArr[counter].duskDawnFlag,
          "scheduleDuskDawnOffset": this.state.schedulesTabArr[counter].duskDawnOffset,
          "scheduleDaysOfWeek": this.state.schedulesTabArr[counter].daysOfWeek,
          "scheduleLastCmd": this.state.schedulesTabArr[counter].lastCmd,
          "scheduleSynchStatus": this.state.schedulesTabArr[counter].synchStatus,
          "profile": "",
          "id": this.state.schedulesTabArr[counter].profile.id,
          "name": this.state.schedulesTabArr[counter].profile.name,
          "accountId": this.state.schedulesTabArr[counter].profile.accountId,
          "lastCmd": this.state.schedulesTabArr[counter].profile.lastCmd,
          "maxLoadLevel": this.state.schedulesTabArr[counter].profile.maxLoadLevel,
          "minLoadLevel": this.state.schedulesTabArr[counter].profile.minLoadLevel,
          "lux": this.state.schedulesTabArr[counter].profile.lux,
          "ambientLight": this.state.schedulesTabArr[counter].profile.ambientLight,
          "activityTimeout": this.state.schedulesTabArr[counter].profile.activityTimeout,
          "trigger": this.state.schedulesTabArr[counter].profile.trigger,
          "beeperVolume": this.state.schedulesTabArr[counter].profile.beeperVolume,
          "powerLedMax": this.state.schedulesTabArr[counter].profile.powerLedMax,
          "powerLedMin": this.state.schedulesTabArr[counter].profile.powerLedMin,
          "lingerTimeout": this.state.schedulesTabArr[counter].profile.lingerTimeout,
          "lingerLoadLevel": this.state.schedulesTabArr[counter].profile.lingerLoadLevel,
          "indLedMax": this.state.schedulesTabArr[counter].profile.indLedMax,
          "indLedMin": this.state.schedulesTabArr[counter].profile.indLedMin,
          "rampUp": this.state.schedulesTabArr[counter].profile.rampUp,
          "rampDown": this.state.schedulesTabArr[counter].profile.rampDown,
          "contAct": this.state.schedulesTabArr[counter].profile.contAct,
          "modeType": this.state.schedulesTabArr[counter].profile.modeType,
          "manualModeType": this.state.schedulesTabArr[counter].profile.manualModeType,
          "manualModeTo": this.state.schedulesTabArr[counter].profile.manualModeTo,
          "followPrevProfile": profile_followPrevProfile,
          "manualLoadOff": profile_manualLoadOff,
          "ledsAutoAdjust": profile_ledsAutoAdjust,
          "synchStatus": this.state.schedulesTabArr[counter].profile.synchStatus
        });
      }
    }
    let schedulesData = [];
    if (this.state.scheduleColumns.length > 0) {
      for (var countr = 0; countr < this.state.scheduleColumns.length; countr++) {
        let rowSchedule = {};
        let cnt = 0;
        for (var i in this.state.scheduleColumns[countr]) {
          let accSchedule = "colsch" + cnt;
          rowSchedule[accSchedule] = this.state.scheduleColumns[countr][i];
          cnt++;
        }
        schedulesData.push(rowSchedule);
      }
    }
    let columnSchedule = [];
    if (this.state.scheduleColumns.length > 0) {
      for (let counter = 0; counter < this.state.scheduleColumns.length; counter++) {
        let columnAccessor = "colsch" + counter;
        if (this.state.scheduleColumns[counter] !== undefined) {
          if (counter === 0) {
            columnSchedule.push(
              {
                Header: "",
                accessor: columnAccessor,
                style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: "#337ab7", color: "#FFFFFF" }
              }
            )
          } else {
            if (this.state.activeScheduleId !== "") {
              columnSchedule.push(
                {
                  Header: "",
                  accessor: columnAccessor,
                  style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: this.state.scheduleColumns[counter].scheduleId === this.state.activeScheduleId ? "#23b14d" : "#cfd5e9", color: "#000000" },
                }
              )
            } else {
              columnSchedule.push(
                {
                  Header: "",
                  accessor: columnAccessor,
                  style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: "#cfd5e9", color: "#000000" },
                }
              )
            }
          }
        }
      }
    }
    let tabData = [];
    for (let cnt = 0; cnt < schedulesData.length; cnt++) {
      if (cnt === 0) {
        for (let cnter in schedulesData[cnt]) {
          if (schedulesData[cnt][cnter] === "Profile") {
            tabData.push({ "colsch0": schedulesData[cnt][cnter] });
          } else {
            tabData.push({ "colsch0": schedulesData[cnt][cnter] });
          }
        }
      } else {
        let scheduleTypeArr = [];
        for (let i_new in schedulesData[cnt]) {
          if (schedulesData[cnt][i_new] === "Profile") {
            scheduleTypeArr.push(schedulesData[cnt][i_new]);
          } else {
            scheduleTypeArr.push(schedulesData[cnt][i_new]);
          }
        }
        let keyNme = "colsch" + cnt;
        for (let n = 0; n < scheduleTypeArr.length; n++) {
          tabData[n][keyNme] = scheduleTypeArr[n];
        }
        if (schedulesData.length - 1 === cnt) {
          this.setState({ schedulesTabData: tabData, columnSchedule: columnSchedule, isSchedulesTab: true });
        }
      }

    }
  }


  displayScenes() {
    let columnsScenes = [];
    columnsScenes.push({
      "accountSceneId": "Account Scene Id",
      "sceneId": "Scene Id",
      "sceneName": "Name",
      "sceneLoadLevel": "Load Level",
      "sceneLastCmd": "Last cmd",
      "sceneSynchStatus": "Synch Status"
    });
    if (this.state.scenesTabArr.length > 0) {
      for (let counterScenes = 0; counterScenes < this.state.scenesTabArr.length; counterScenes++) {
        columnsScenes.push({
          "accountSceneId": this.state.scenesTabArr[counterScenes].accountSceneId,
          "sceneId": this.state.scenesTabArr[counterScenes].id,
          "sceneName": this.state.scenesTabArr[counterScenes].name,
          "sceneLoadLevel": this.state.scenesTabArr[counterScenes].loadLevel,
          "sceneLastCmd": this.state.scenesTabArr[counterScenes].lastCmd,
          "sceneSynchStatus": this.state.scenesTabArr[counterScenes].synchStatus
        });
      }
    }

    const scenesData = [];
    if (columnsScenes.length > 0) {
      for (var countrScenes = 0; countrScenes < columnsScenes.length; countrScenes++) {

        let rowSchScenes = {};
        let cntScenes = 0;
        for (var iScenes in columnsScenes[countrScenes]) {
          let accSchScenes = "colschScenes" + cntScenes;
          rowSchScenes[accSchScenes] = columnsScenes[countrScenes][iScenes];
          cntScenes++;
        }
        scenesData.push(rowSchScenes);

      }
    }
    let columnScene = [];
    if (columnsScenes.length > 0) {
      for (let counterScenes = 0; counterScenes < columnsScenes.length; counterScenes++) {
        let colAccessorScenes = "colschScenes" + counterScenes;
        if (columnsScenes[counterScenes] !== undefined) {
          if (counterScenes === 0) {
            columnScene.push(
              {
                Header: "",
                accessor: colAccessorScenes,
                style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: "#337ab7", color: "#FFFFFF" },
              }
            )
          } else {
            if (this.state.activeSceneId !== "") {
              columnScene.push(
                {
                  Header: "",
                  accessor: colAccessorScenes,
                  style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: columnsScenes[counterScenes].scene_id === this.state.activeSceneId ? "#23b14d" : "#cfd5e9", color: "#000000" },
                }
              )
            } else {
              columnScene.push(
                {
                  Header: "",
                  accessor: colAccessorScenes,
                  style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: "#cfd5e9", color: "#000000" },
                }
              )
            }
          }
        }
      }
    }
    let scenesTabData = [];
    for (let cntScenes = 0; cntScenes < scenesData.length; cntScenes++) {
      if (cntScenes === 0) {
        for (var cnterScenes in scenesData[cntScenes]) {
          if (scenesData[cntScenes][cnterScenes] === "Profile") {
            scenesTabData.push({ "colschScenes0": scenesData[cntScenes][cnterScenes] });
          } else {
            scenesTabData.push({ "colschScenes0": scenesData[cntScenes][cnterScenes] });
          }
        }
      } else {
        let scenesArr = [];
        for (var i_Scenes in scenesData[cntScenes]) {
          scenesArr.push(scenesData[cntScenes][i_Scenes]);
        }
        let keyNmeScenes = "colschScenes" + cntScenes;
        for (var nScenes = 0; nScenes < scenesArr.length; nScenes++) {
          scenesTabData[nScenes][keyNmeScenes] = scenesArr[nScenes];

        }
      }
      if (scenesData.length - 1 === cntScenes) {
        this.setState({ scenesTabData: scenesTabData, columnScene: columnScene, isScenesTab: true });
      }
    }
  }
  
  displayGlobalSettings(settings) {
    let data = [];
    data.push({
      "id": "Id",
      "accountId": "Account Id",
      "activitySensitivity": "Activity Sensitivity",
      "aggressiveBackOff": "Aggressive Back Off",
      "aggressiveBackOffThreshold": "Aggressive Back Off Threshold",
      "ambientBackOff": "Ambient Back Off",
      "ambientSensitivity": "Ambient Sensitivity",
      "autoAwake": "Auto Awake",
      "autoAwakeStartHour": "Auto Awake Start Hour",
      "autoAwakeStartMin": "Auto Awake Start Min",
      "autoSleep": "Auto Sleep",
      "autoSleepStartHour": "Auto Sleep Start Hour",
      "autoSleepStartMin": "Auto Sleep Start Min",
      "deviceStrobing": "Device Strobing",
      "maxAggressiveBackOff": "Max Aggressive Back Off",
      "nightLampOn": "Night Lamp On",
      "nightLampOnMotion": "Night Lamp On Motion",
      "overrideTimeout": "Override Timeout",
      "powerBtnOnLvl": "Power Button On Level",
      "rememberNightLampLevel": "Remember Night Lamp Level",
      "rockerBtnOnLvl": "Rocker Button On Level",
      "safetyLux": "Safety Lux",
      "sceneId": "Scene Id",
      "switchMode": "Switch Mode",
      "synchStatus":"Synch Status"
    });
    if (settings) {
        data.push({
          "id": settings.id,
          "accountId": settings.accountId,
          "activitySensitivity": settings.activitySensitivity,
          "aggressiveBackOff": settings.aggressiveBackOff ? 'true': 'false',
          "aggressiveBackOffThreshold": settings.aggressiveBackOffThreshold,
          "ambientBackOff": settings.ambientBackOff,
          "ambientSensitivity": settings.ambientSensitivity,
          "autoAwake": settings.autoAwake ? 'true': 'false',
          "autoAwakeStartHour": settings.autoAwakeStartHour,
          "autoAwakeStartMin": settings.autoAwakeStartMin,
          "autoSleep": settings.autoSleep ? 'true': 'false',
          "autoSleepStartHour": settings.autoSleepStartHour,
          "autoSleepStartMin": settings.autoSleepStartMin,
          "deviceStrobing": settings.deviceStrobing,
          "maxAggressiveBackOff": settings.maxAggressiveBackOff,
          "nightLampOn": settings.nightLampOn ? 'true': 'false',
          "nightLampOnMotion": settings.nightLampOnMotion ? 'true': 'false',
          "overrideTimeout": settings.overrideTimeout,
          "powerBtnOnLvl": settings.powerBtnOnLvl,
          "rememberNightLampLevel": settings.rememberNightLampLevel ? 'true': 'false',
          "rockerBtnOnLvl": settings.rockerBtnOnLvl,
          "safetyLux": settings.safetyLux,
          "sceneId": settings.sceneId ? settings.sceneId: '-',
          "switchMode": settings.switchMode,
          "synchStatus": settings.synchStatus
        });
    }
    let settingsData = [];
    if (data.length > 0) {
      for (var countr = 0; countr < data.length; countr++) {
        let rowSettings = {};
        let cnt = 0;
        for (var i in data[countr]) {
          let accSettings = "colGlobal" + cnt;
          rowSettings[accSettings] = data[countr][i];
          cnt++;
        }
        settingsData.push(rowSettings);
      }
    }

    let columnGlobalSettings = [];
    if (data.length > 0) {
      for (let counter = 0; counter < data.length; counter++) {
        let colAccessorScenes = "colGlobal" + counter;
        if (data[counter] !== undefined) {
          if (counter === 0) {
            columnGlobalSettings.push(
              {
                Header: "",
                accessor: colAccessorScenes,
                style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: "#337ab7", color: "#FFFFFF" },
              }
            )
          } else {
            columnGlobalSettings.push(
              {
                Header: "",
                accessor: colAccessorScenes,
                style: { textAlign: "center", "borderWidth": "1.5px", 'borderColor': "#ffffff", 'borderStyle': 'solid', background: "#cfd5e9", color: "#000000" },
              }
            )
          }
        }
      }
    }

    let tabData = [];
    for (let cnt = 0; cnt < settingsData.length; cnt++) {
      if (cnt === 0) {
        for (let cnter in settingsData[cnt]) {
          tabData.push({ "colGlobal0": settingsData[cnt][cnter] });
        }
      } else {
        let settingsTypeArr = [];
        for (let i_new in settingsData[cnt]) {
          settingsTypeArr.push(settingsData[cnt][i_new]);
        }
        let keyNme = "colGlobal" + cnt;
        for (let n = 0; n < settingsTypeArr.length; n++) {
          tabData[n][keyNme] = settingsTypeArr[n];
        }
        if (settingsData.length - 1 === cnt) {
          this.setState({ globalSettingsTabData: tabData, columnGlobalSettings: columnGlobalSettings, isGlobalSettingsTab: true });
        }
      }
    }

  }

  setGroupConfigFromShadow(shadowGroupConfig) {
    let config = {};
    config[this.EVENT.MOTION] = this.getEventInfo(this.EVENT.MOTION, shadowGroupConfig.eventConfig);
    config[this.EVENT.AMBIENT] = this.getEventInfo(this.EVENT.AMBIENT, shadowGroupConfig.eventConfig);
    config[this.EVENT.BUTTON] = this.getEventInfo(this.EVENT.BUTTON, shadowGroupConfig.eventConfig);
    config[this.EVENT.LED] = this.getEventInfo(this.EVENT.LED, shadowGroupConfig.eventConfig);
    return config;
  }

  getEventInfo(event, shadowGroupConfig) {
    let eventInfo = {};
    let publishMember = this.getMemberArray(shadowGroupConfig[event].Publish);
    let consumeMember = this.getMemberArray(shadowGroupConfig[event].Consume);
    eventInfo["publish"] = publishMember;
    eventInfo["consume"] = consumeMember;
    return eventInfo;
  }

  getMemberArray(membersMac) {
    let memberString = ""
    for(const mac of membersMac) {
      memberString= this.getNameForDevice(mac)+", ";
    }

    return memberString.substring(0, (memberString.length-2));
  }

  getNameForDevice(mac) {
    if (this.props.deviceList === undefined) {
      return mac;
    }
    for (const device of this.props.deviceList) {
      if (device.hasOwnProperty("mac") && mac === device.mac) {
        return device.name;
      }
    }
    return mac;
  }

  getPublishMembers(event) {
    if(this.state.shadowGroupConfig && this.state.shadowGroupConfig[event]) {
      return (this.state.shadowGroupConfig[event].publish.length != 0 ? this.state.shadowGroupConfig[event].publish : "  -");
    }
  }

  getConsumeMembers(event) {
    if(this.state.shadowGroupConfig && this.state.shadowGroupConfig[event]) {
      return (this.state.shadowGroupConfig[event].consume.length != 0 ? this.state.shadowGroupConfig[event].consume : "  -");
    }
  }

  async getGroups() {
    try {
      const groupsData = await DashboardService.getGroups(this.state.macAddress);
      if (this.state.isActive === NAVTYPE.GROUPS) {
        this.displayGroups(groupsData);
      }
    } catch(e) {
      console.log(e);
    }
  }

  displayGroups(groupsData) {
    if(groupsData.length > 0) {
      const groupColumns =  [{
            Header: "Id",
            accessor: "groupId",
            width: 40
        },
        {
            Header: "Name",
            accessor: "name"
        },
        {
            Header: "Type",
            accessor: "type",
            width: 100
        },
        {
            Header: "Cmd",
            accessor: "cmd",
            width: 40
        },
        {
            Header: 'Group sync status',
            accessor: "syncStatus",
            width: 50
        },
        {
            Header: 'Device type',
            accessor: 'deviceType',
            width: 70
        },
        {
          Header: 'Source',
          accessor: 'sourceId',
          width: 100
        },
        {
          Header: 'Target',
          accessor: 'targetId',
          width: 100
        },
        {
          Header: 'Event',
          accessor: 'event',
          width: 100
        },
        {
          Header: 'Source sync status',
          accessor: 'sourceSyncStatus',
          width: 50
        },
          {
            Header: 'Target sync status',
            accessor: 'targetSyncStatus',
            width: 50
        },
        {
          Header: 'Source ipaddr sync status',
          accessor: 'sourceIpaddrSyncStatus',
          width: 50
       },
        {
          Header: 'Target ipaddr sync status',
          accessor: 'targetIpaddrSyncStatus',
          width: 50
      }
      ]
      const groupTabData = this.createFlatStructureForGroupData(groupsData);
      this.setState({groupColumns: groupColumns, isGroupTab: true, groupTabData: groupTabData})
    } else {
      this.setState({isGroupTab: false})
    }
  }

  createFlatStructureForGroupData(groupsData) {
      let groupTabData = [];
      for(const groupData of groupsData) {
        let groupInfo = {};
        groupInfo.groupId = groupData.groupId;
        groupInfo.name = groupData.name;
        groupInfo.type = groupData.type;
        groupInfo.cmd = this.getGroupCmdValue(groupData.cmd);
        groupInfo.syncStatus = groupData.syncStatus;
        groupInfo.deviceType = (groupData.noLoadDevice == true) ? "No Load Device" : "Load Device";
        groupTabData.push(groupInfo)
        for(const eventConfig of groupData.deviceEventConfig) {
          let config = {};
          config.sourceId = this.getDeviceNameForSource(eventConfig);
          config.targetId = this.getDeviceNameForTarget(eventConfig);
          config.event = eventConfig.event;
          config.sourceSyncStatus = eventConfig.sourceSyncStatus;
          config.targetSyncStatus = eventConfig.targetSyncStatus;
          config.sourceIpaddrSyncStatus = eventConfig.sourceIpaddrSyncStatus;
          config.targetIpaddrSyncStatus = eventConfig.targetIpaddrSyncStatus;
          groupTabData.push(config);
        }
      }

      return groupTabData
  }

  getGroupCmdValue(cmd) {
    switch(cmd) {
      case 1: return "Add";
      case 2: return "Edit";
      case 3: return "Delete";
      default: return "Unrecognised cmd"
    }
  }

  getDeviceNameForSource(eventConfig) {
    if (this.props.deviceList !== undefined) {
      for (const device of this.props.deviceList) {
        if (eventConfig.sourceId === device.id) {
          return device.name;
        }
      }
    } else if (eventConfig.hasOwnProperty("sourceMac")) {
      return eventConfig.sourceMac;
    }
    return eventConfig.sourceId;
  }

  getDeviceNameForTarget(eventConfig) {
    if (this.props.deviceList !== undefined) {
      for (const device of this.props.deviceList) {
        if (eventConfig.targetId === device.id) {
          return device.name;
        }
      }
    } else if (eventConfig.hasOwnProperty("targetMac")) {
      return eventConfig.targetMac;
    }
    return eventConfig.targetId;
  }

  render() {
    return (
      <Modal open={this.props.deviceConfigShow} onClose={this.onCloseClicked} classNames={{ modal: 'customModal' }}>
        <Row id="device" style={{margin: 20}}>
          <Col sm={5}></Col>
          <Col sm={3}>
            <h4>Device Configuration</h4>
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="add-pane"></Col>
        </Row>
        <Row>
          <Col sm={1}></Col>
          <Col sm={4}>
           {this.renderAreaInfo()}
          </Col>
          <Col sm={2}></Col>
          <Col sm={4}>
            {this.renderDeviceInfo()}
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <div className="add-pane"></div>
          </Col>
        </Row>
        <Row>
          <Col sm={1}></Col>
          <Col sm={10}>
            <div className="toplefttable topdiv-height">
              <div className="col-md-12">
                {this.renderShadowScheduleConfig()}
                {this.renderRefreshButton()}
              </div>
              <div className="col-md-12 mid-pane"></div>
                {this.renderShadowSceneConfig()}
                <div className="col-md-12 add-pane"></div>
                {this.renderShadowGroupConfig()}
                <div className="col-md-12 mid-pane"></div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}></Col>
        </Row>
        <Row>
          <Col sm={12}></Col>
        </Row>
        <Row>
          <Col sm={12}>
            <div className="mid-sp-pane"></div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}></Col>
          <Col sm={5}>
            <div className="lft-margin">
              <ul className="nav nav-pills ul-links">
                <li className={this.state.isActive === NAVTYPE.SCHEDULES ? 'active rght-margin' : 'inactive rght-margin'} id="li_schedules">
                  <a href="#device" data-toggle="tab" onClick={() => this.changeActiveNavPill(NAVTYPE.SCHEDULES)}>Schedules</a>
                </li>
                <li className={this.state.isActive === NAVTYPE.SCENES ? 'active rght-margin' : 'inactive rght-margin'} id="li_scenes">
                  <a href="#device" data-toggle="tab" onClick={() => this.changeActiveNavPill(NAVTYPE.SCENES)}>Scenes</a>
                </li>
                <li className={this.state.isActive === NAVTYPE.GROUPS ? 'active rght-margin' : 'inactive rght-margin'} id="li_groups">
                  <a href="#device" data-toggle="tab" onClick={() => this.changeActiveNavPill(NAVTYPE.GROUPS)}>Groups</a>
                </li>
                <li className={this.state.isActive === NAVTYPE.GLOBAL_SETTINGS ? 'active rght-margin' : 'inactive rght-margin'} id="li_groups">
                  <a href="#device" data-toggle="tab" onClick={() => this.changeActiveNavPill(NAVTYPE.GLOBAL_SETTINGS)}>Global Settings</a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <div className="mid-pane"></div>
          </Col>
        </Row>
        <Row>
          <Col sm={1}></Col>
          <Col sm={10}>
            <div className="tab-content clearfix borderpane">
              {this.renderScheduleConfig()}
              {this.renderSceneConfig()}
              {this.renderGroupConfig() }
              {this.renderGlobalSettings()}
            </div>
          </Col>
        </Row>
      </Modal>
    )
  }

  renderAreaInfo() {
    return (
      <div>
      <div className="toplefttable">
        <div>
          <span>User: </span>
          <span>{this.state.userId}</span>
        </div>
        <div>
          <span>Premise: </span>
          <span>{this.state.premiseName}</span>
        </div>
        <div>
          <span>Area: </span>
          <span>{this.state.areaName}</span>
        </div>
      </div>
    </div>
    )
  }


  renderDeviceInfo() {
    return (
      <div className="">
      <div className="toplefttable">
        <div>
          <span>Device: </span>
          <span>{this.state.deviceName}</span>
        </div>
        <div>
          <span>Mac: </span>
          <span>{this.state.macAddress}</span>
        </div>
        <div>
          <span>&nbsp; </span>
          <span id="testId"></span>
        </div>
      </div>
    </div>
    )
  }

  renderRefreshButton() {
    return (
      <div className="col-md-1">
      <a
        href="#/"
        role="button"
        variant="info"
        style={{ cursor: "pointer", textDecoration: "none", float: "right", paddingTop: "15px", paddingRight: "5px" }}
        onClick={() =>
          this.getSchedulesProfilesReload(this.state.macAddress)
        }
      ><img
          key="reloadButton_img_key"
          id="reloadButton_img"
          src={imageURIs.reload_button}
          alt="Reload"
          title="Reload"
          className="reload_btn"
        />
      </a>
    </div>
    )
  }

  renderShadowScheduleConfig() {
    return (
      <div className="col-md-11">
          <div id="exTab3" className="tab-content clearfix borderpane-top">
            {this.state.isSchedulesProfiles === true &&
              <Table
              data={this.state.tableData}
              columns={this.state.scheduleProfileColumns}
              showPagination={false}
              defaultPageSize={1}
              noDataText=""
              style={{ width: "100%", padding: "10px" }}
            />
            }
            {this.state.isSchedulesProfiles === false &&
              <div className="div-noschedules-topdiv">
                <span>There are no schedules and profiles to show.</span>
              </div>
            }
            {this.state.isSchedulesProfiles === null && this.state.macIdSet === true &&
              <div className="div-noschedules-topdiv-loading">
                <span>Loading...</span>
              </div>
            }
          </div>
        </div>
    )
  }

  renderShadowSceneConfig() {
    return (
      <div className="col-md-12 scene-font-size">
        <div className="col-md-1">
            <span>&nbsp;</span>
          </div>
          <div className="col-md-5">
            <span>Scenes: </span>
            <span>{this.state.scenesArr}</span>
          </div>
          <div className="col-md-1">
            <span>&nbsp;</span>
          </div>
          <div className="col-md-5">
            <span>Active Scene: </span>
            <span>{this.state.activeSceneId}</span>
         </div>
      </div>
    )
  }

  renderShadowGroupConfig() {
     return (
      <div className="col-md-12">
         <div className="col-md-5 group-font-size">
            <span> Group Configuration: </span>
        </div>
        {(Object.keys(this.state.shadowGroupConfig).length != 0) ? 
        <div>
        <div className="col-md-12">
            <div className="col-md-12 mid-pane"></div>
            <div className="col-md-12 mid-pane"></div>
            <span> Motion Event </span>
              <div>
                <span>Publish to : {this.getPublishMembers(this.EVENT.MOTION)}</span>
              </div>
              <div>
                <span>Consume from : {this.getConsumeMembers(this.EVENT.MOTION)}</span>
              </div>
            </div>
            <div className="col-md-12">
            <div className="col-md-12 mid-pane"></div>
              <span> Ambient Event </span>
              <div>
                <span>Publish to : {this.getPublishMembers(this.EVENT.AMBIENT)}</span>
              </div>
              <div>
                <span>Consume from : {this.getConsumeMembers(this.EVENT.AMBIENT)}</span>
              </div>
            </div>
            <div className="col-md-12">
            <div className="col-md-12 mid-pane"></div>
            <div>
            <span> LED Event </span>
              <div>
                <span>Publish to : {this.getPublishMembers(this.EVENT.LED)}</span>
              </div>
              <div>
                <span>Consume from : {this.getConsumeMembers(this.EVENT.LED)}</span>
              </div>
              </div>
            </div>
            <div className="col-md-12">
            <div className="col-md-12 mid-pane"></div>
            <span> Button Event </span>
              <div>
                <span>Publish to : {this.getPublishMembers(this.EVENT.BUTTON)}</span>
              </div>
              <div>
                <span>Consume from : {this.getConsumeMembers(this.EVENT.BUTTON)}</span>
              </div>
            </div>
            </div>
            :
            <div className="col-md-5 group-font-size">
              <span>No configuration present</span>
            </div>
        }
      </div>
     );
  }

  renderScheduleConfig() {
    return (
      <div>
      {this.state.isActive === NAVTYPE.SCHEDULES &&
        <div className="tab-pane active" id="schedules">
          {this.state.isSchedulesTab === true &&
            <Table
              data={this.state.schedulesTabData}
              columns={this.state.columnSchedule}
              showPagination={false}
              defaultPageSize={38}
              noDataText=""
              style={{ width: "100%", padding: "10px" }}
            />
          }
          {this.state.isSchedulesTab === false &&
            <div className="div-noschedules-topdiv">
              <span>There are no schedules to show.</span>
            </div>
          }
          {this.state.isSchedulesTab === null &&
            <div className="div-noschedules-topdiv-loading">
              <span>Loading...</span>
            </div>
          }
        </div>
      }
      </div>
    )
  }

  renderSceneConfig() {
    return (
      <div>
        {this.state.isActive === NAVTYPE.SCENES &&
            <div className="tab-pane active" id="scenes">
              {this.state.isScenesTab === true &&
                <Table
                  data={this.state.scenesTabData}
                  columns={this.state.columnScene}
                  showPagination={false}
                  defaultPageSize={5}
                  noDataText=""
                  style={{ width: "100%", padding: "10px" }}
                />
              }
              {this.state.isScenesTab === false &&
                <div className="div-noschedules-topdiv">
                  <span>There are no scenes to show.</span>
                </div>
              }
              {this.state.isScenesTab === null &&
                <div className="div-noschedules-topdiv-loading">
                  <span>Loading...</span>
                </div>
              }
            </div>
          }
      </div>
    )
  }

  renderGlobalSettings() {
    return (
      <div>
        {this.state.isActive === NAVTYPE.GLOBAL_SETTINGS &&
            <div className="tab-pane active" id="scenes">
              {this.state.isGlobalSettingsTab === true &&
                <Table
                  data={this.state.globalSettingsTabData}
                  columns={this.state.columnGlobalSettings}
                  showPagination={false}
                  defaultPageSize={25}
                  noDataText=""
                  style={{ width: "100%", padding: "10px" }}
                />
              }
              {this.state.isGlobalSettingsTab === false &&
                <div className="div-noschedules-topdiv">
                  <span>No global settings data present.</span>
                </div>
              }
              {this.state.isGlobalSettingsTab === null &&
                <div className="div-noschedules-topdiv-loading">
                  <span>Loading...</span>
                </div>
              }
            </div>
          }
      </div>
    )
  }

  renderGroupConfig() {
    return (
      <div>
        {this.state.isActive === NAVTYPE.GROUPS &&
            <div className="tab-pane active" id="groups">
              {this.state.isGroupTab === true &&
                 <Table
                 data={this.state.groupTabData}
                 columns={this.state.groupColumns}
                 defaultPageSize={50}
                 noDataText=""
                 style={{ width: "100%", padding: "10px" }}
                 />
              }
              {this.state.isGroupTab === false &&
                <div className="div-noschedules-topdiv">
                  <span>There are no groups to show.</span>
                </div>
              }
              {this.state.isGroupTab === null &&
                <div className="div-noschedules-topdiv-loading">
                  <span>Loading...</span>
                </div>
              }
            </div>
        }
      </div>
    )
  }
}

const getDeviceListForPremises = (state, props) => {
  let deviceList = [];
  if(state.userInfoReducer.premiseData){
    for(const premises of state.userInfoReducer.premiseData) {
      if(props.premises.id == premises.id) {
        for(const area of premises.areas) {
              if(area.devices && area.devices.length != 0) {
                for(const device of area.devices) {
                  deviceList.push(device)
                }
              }
          }
          return deviceList;
      }
    }
  } else{
    return deviceList;
  }
}

const mapStateToProps = (state, props) => {
  let deviceList = []
  if(Object.keys(props.premises).length != 0) {
    deviceList = getDeviceListForPremises(state, props);
  }
  return {
    deviceList: deviceList
  };
};

const R_DeviceConfigModal = connect(mapStateToProps)(DeviceConfigModal);
export default R_DeviceConfigModal;